/**
 * Helper functions for chef's recommendation feature
 */

/**
 * Determines if a time is eligible to be considered for chef's recommendation
 * based on various exclusion rules.
 * 
 * @param {string} timeValue - Time in "HH:MM" format
 * @returns {boolean} - Whether the time is eligible
 */
export function isTimeEligibleForChefsRecommendation(timeValue) {
	// Base excluded times (traditionally busy periods)
	const excludedTimes = ['12:00', '12:30', '19:00', '19:30'];
	
	// Parse time
	const [hours, minutes] = timeValue.split(':').map(Number);
	
	// Check if time is 20:00 or later
	if (hours >= 20) {
	  return false;
	}
	
	// Check if time is between 13:00 and 15:00 (including 13:00)
	if (hours >= 13 && hours < 15) {
	  return false;
	}
	
	// Check against the original excluded times
	return !excludedTimes.includes(timeValue);
  }
  
  /**
   * Gets a chef's recommendation from available times.
   * Returns null if no eligible times are available.
   * 
   * @param {Array} availableTimes - Array of time objects with {value, label}
   * @returns {string|null} - The recommended time value or null
   */
  export function getChefsRecommendation(availableTimes) {
	if (!availableTimes || availableTimes.length === 0) {
	  return null;
	}
	
	// Filter eligible times based on rules
	const eligibleTimes = availableTimes.filter(time => 
	  isTimeEligibleForChefsRecommendation(time.value)
	);
	
	if (eligibleTimes.length === 0) {
	  return null;
	}
	
	// Choose a random time from eligible times
	const randomIndex = Math.floor(Math.random() * eligibleTimes.length);
	return eligibleTimes[randomIndex].value;
  }
  
  /**
   * Updates time objects with chef's recommendation label
   * 
   * @param {Array} times - Array of time objects with {value, label}
   * @param {string} recommendedTime - The time value recommended by chef
   * @returns {Array} - Updated array of time objects
   */
  export function applyRecommendationLabel(times, recommendedTime) {
	if (!recommendedTime) {
	  return times;
	}
	
	return times.map(time => {
	  if (time.value === recommendedTime) {
		return {
		  ...time,
		  label: `${time.label} - Chef's aanrader`
		};
	  }
	  return time;
	});
  }